import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, map, filter } from 'rxjs';

@Injectable()
export class LoanInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes('/api/loan/client-api/v1/loans/')) {
      const arr = request.url.split('client-api/v1/loans/');
      const dupReq = request.clone({ url: '/api/arrangement-manager/client-api/v2/arrangements/' + arr[1] });
      return next.handle(dupReq).pipe(
        filter((event) => event instanceof HttpResponse),
        map((event: HttpResponse<any>) => {
          event.body.loanType = 'TermLoan';
          event.body.alias = event.body.bankAlias ? event.body.bankAlias : '';
          event.body.interestRate = event.body.accountInterestRate ? event.body.accountInterestRate : '';
          event.body.accountNumber = event.body.BBAN ? event.body.BBAN : '';
          event.body.name = event.body.productKindName ? event.body.productKindName : '';
          event.body.termUnit = this.getTermUnit(event.body.termUnit ? event.body.termUnit : '');
          event.body.termCount = event.body.termNumber ? event.body.termNumber : '';
          event.body.creditLimit = event.body.principalAmount ? event.body.principalAmount : '';
          event.body.outstandingAmount = event.body.outstandingPrincipalAmount
            ? event.body.outstandingPrincipalAmount
            : '';
          event.body.currencyCode = event.body.currency ? event.body.currency : '';
          event.body.nextRepaymentDate = event.body.additions?.nextLoanInstalmentAmount
            ? event.body.additions?.nextLoanInstalmentAmount
            : '';
          event.body.nextRepaymentAmount = event.body.monthlyInstalmentAmount ? event.body.monthlyInstalmentAmount : '';
          return event;
        }),
      );
    }
    return next.handle(request);
  }

  getTermUnit(unit: string): string {
    if (unit === 'D') {
      return 'Day';
    }
    if (unit === 'W') {
      return 'Week';
    }
    if (unit === 'M') {
      return 'Month';
    }
    if (unit === 'Y') {
      return 'Year';
    }
    return '';
  }
}
